@if (!isLoaded()) {
  <app-egg-spinner-overlay></app-egg-spinner-overlay>
} @else {
  <app-header-nav></app-header-nav>
  <main class="main-container app-containerv--offers bg-beige">
    <router-outlet></router-outlet>
  </main>
  <app-simplified-footer
    [showPayoffDisclosures]="false"
  ></app-simplified-footer>
}
